module.exports = __webpack_public_path__ + "img/5.a8248eb2.jpg";